import React from "react";

const Video = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13" height="11.375" viewBox="0 0 13 11.375">
			<path
				id="icon-video"
				d="M1.271,4A.271.271,0,0,0,1,4.271V15.1a.271.271,0,0,0,.271.271H13.729A.271.271,0,0,0,14,15.1V4.271A.271.271,0,0,0,13.729,4Zm.271.542h.813v.813H1.542Zm1.354,0H3.979v.813H2.9Zm1.625,0H5.6v.813H4.521Zm1.625,0H7.229v.813H6.146Zm1.625,0H8.854v.813H7.771Zm1.625,0h1.083v.813H9.4Zm1.625,0H12.1v.813H11.021Zm1.625,0h.813v.813h-.812ZM6.417,8.063,9.125,9.688,6.417,11.313ZM1.542,14.021h.813v.812H1.542Zm1.354,0H3.979v.812H2.9Zm1.625,0H5.6v.812H4.521Zm1.625,0H7.229v.812H6.146Zm1.625,0H8.854v.812H7.771Zm1.625,0h1.083v.812H9.4Zm1.625,0H12.1v.812H11.021Zm1.625,0h.813v.812h-.812Z"
				transform="translate(-1 -4)"
				fill="#fff"
				opacity="0.5"
			/>
		</svg>
	);
};

export default Video;
